module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/vuetable-2/~/axios/index.js
// module id = 4ik2
// module chunks = 22